import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { config } from '../_models/apiConfig';

const URL = "http://localhost:8086/";

@Injectable()
export class ApiService {

  constructor(private http: Http) {

  }
  jwt() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return headers;
  }

  sqlGet(path) {
    return this.http.get(config.development + path).map(res => res.json());
  }

  sqlPost(path, data) {
    return this.http.post(config.development + path, JSON.stringify(data), { headers: this.jwt() });
  }
  sqlUpdate(path, data) {
    this.http.put(config.development + path, JSON.stringify(data)).map(res => res.json());
  }

  sqlDelete(path, data) {
    return this.http.post(config.development + path + '?id=' + data, JSON.stringify(data)).map(res => res.json());
  }
  sqlDeleteuniquename(path, data) {
    return this.http.post(config.development + path + '?uniqueName=' + data, JSON.stringify(data)).map(res => res.json());
  }

  editToSql(newPost, userId, path) {

    let postSql = {
      key: newPost.key,
      likes: newPost.likes ? newPost.likes : 0,
      comments: newPost.comments ? newPost.comments.length : 0,
      reposts: newPost.reposts ? newPost.reposts : 0,
      favorites: newPost.followers ? newPost.followers.length : 0,
      innerText: newPost.innerText,
      text: newPost.text,
      modifyDate: new Date(newPost.modifyDate),
      isAllowComments: newPost.settings.isAllowComments,
      isGlobal: newPost.settings.isGlobal,
      isNameSecret: newPost.settings.isNameSecret,
      isOnlyFriend: newPost.settings.isOnlyFriend,
      userKey: userId,
      valueOf: newPost.valueOf,
      uniqueName: newPost.rating.uniqueName,
      category: newPost.rating.category,
      userRate: newPost.rating.userRate,
      type: newPost.rating.type,
      oldPoint: newPost.oldPoint || null,
      answeredDate: newPost.answeredDate ? new Date(newPost.answeredDate) : null
    };
    let postToSql = {
      post: postSql
    };
    this.sqlPost(path, postToSql).subscribe();

  }

  setToSql(key, newPost, isEdit, userId, hashtag) {

    let postSql = {
      key: key,
      likes: 0,
      comments: 0,
      reposts: 0,
      favorites: 0,
      innerText: newPost.innerText,
      text: newPost.text,
      modifyDate: new Date(newPost.modifyDate),
      isAllowComments: newPost.settings.isAllowComments,
      isGlobal: newPost.settings.isGlobal,
      isNameSecret: newPost.settings.isNameSecret,
      isOnlyFriend: newPost.settings.isOnlyFriend,
      userKey: userId,
      valueOf: newPost.valueOf,
      uniqueName: newPost.rating.uniqueName,
      category: newPost.rating.category,
      userRate: newPost.rating.userRate,
      type: newPost.rating.type,
      oldPoint: newPost.oldPoint || null,
      answeredDate: isEdit ? new Date(isEdit.answeredDate) : null,
      isLastPost: true
    };
    let criteriasSql = [];
    newPost.rating.criterias.forEach(data => {
      criteriasSql.push({
        name: data.name,
        point: data.point,
        tooltip: data.tooltip,
        postKey: key,
        uniqueName: newPost.rating.uniqueName
      });
    });
    let hashtagSql = [];
    hashtag.forEach(data => {
      data = data.substring(1);
      hashtagSql.push({ name: data, postKey: key })
    });
    let postToSql = {
      post: postSql,
      criterias: criteriasSql,
      hashtags: hashtagSql
    };
    if (isEdit) {
      this.sqlPost("corporate/editPost", postToSql).subscribe();
    } else {
      this.sqlPost("corporate/insertPost", postToSql).subscribe();
    }

  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/_services/api.service.ts